import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';
import { CalendarTranslateService } from 'app/modules/UIKit/services/calendarTranslate.service';
import { RulesService } from 'app/services/audit/rules.service';
import { Campaign3KontableComponent } from 'app/views/campaign-3/components/campaign-3-kontable/campaign-3-kontable.component';
import { BreadCrumbModel } from 'app/views/campaign-3/models/campaign-3-breadcrumb.model';
import { MessageService, SelectItem } from 'primeng/primeng';
import { ActivatedRoute, Router } from '@angular/router';
import { AuditRuleObject, AuditRulesType } from '../models/audit-event.model';

@Component({
  selector: 'app-rules',
  templateUrl: './rules.component.html',
  styleUrls: ['./rules.component.css']
})
export class RulesComponent implements OnInit {
  @ViewChild('table') table: Campaign3KontableComponent;
  paginationType = Campaign3KontableComponent.ServerPagination;
  customFilter = Campaign3KontableComponent.CustomFilter;
  selectCustomFilter = Campaign3KontableComponent.CustomFilter;
  selectFilter = Campaign3KontableComponent.SelectFilter;
  breadcrumbs: Array<BreadCrumbModel> = [];
  statusList: Array<{ label: string, value: string }>;
  showPopupInfoInsideTable = false;
  noFilter = KontableComponent.NoFilter;
  invalidSubmit = false;
  pageSubject = "Rules";
  translations: any;
  typeRulesList: any;
  dateFilter = Campaign3KontableComponent.DateFilter;
  auditRuleObject: AuditRuleObject = new AuditRuleObject();
  actionsRulesType: Array<AuditRulesType>;
  actionsRulesTypeCombo: { label: string, value: string }[] = [];
  actions: any;
  constructor(
    public rulesService: RulesService,
    public srvCalendar: CalendarTranslateService,
    private router: Router,
    private srvTranslate: TranslateService,
    private srvMessage: MessageService,
    private route: ActivatedRoute
  ) {

    this.loadTypeRules();
  }

  applyInitialIdFilter(id: number) {
    const table = this.table;
    if (table) {
      // Applico il filtro
      table.filter.search = [{ key: 'id', value: String(id) }];
      table.updateTableFilter(null, null, null, 1, 1000, true);

      // Pulisco la ricerca
      table.filter.search = [];

      // Rimuovo il parametro dall'URL
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { ruleId: null },
        queryParamsHandling: 'merge',
        replaceUrl: true
      });
    }
  }

  ruleIdFromRoute: number | null = null;


  ngOnInit() {
    this.initBreadCrumbs();
    this.initStatusList();

    this.route.queryParams.subscribe(params => {
      const id = params['ruleId'];
      if (id) {
        this.ruleIdFromRoute = Number(id);
      }
    });
    setTimeout(() => {
      if (this.ruleIdFromRoute) {
        this.applyInitialIdFilter(this.ruleIdFromRoute);
      }
    }, 200);
  }

  initBreadCrumbs() {
    let bc1 = new BreadCrumbModel();
    bc1.code = "bc1";
    bc1.description = this.srvTranslate.instant('audit.manageEvents');
    this.breadcrumbs.push(bc1);
    let bc2 = new BreadCrumbModel();
    bc2.code = "bc2";
    bc2.description = this.srvTranslate.instant('audit.listRules');
    this.breadcrumbs.push(bc2);
  }

  initStatusList() {
    this.statusList = [
      { value: "0", label: this.srvTranslate.instant('audit.ruleActive') },
      { value: "1", label: this.srvTranslate.instant('audit.ruleDeactive') },
      { value: "2", label: this.srvTranslate.instant('audit.ruleDeleted') },
      { value: null, label: this.srvTranslate.instant('common.all') }];
  }

  onClickAddRule() {
    this.router.navigate(['/rules-list/add', {
      infoBase: this.rulesService.ui_modes.CREATE
    }]);
  }

  onModifyAddRule(idRule: number) {
    this.router.navigate(['/rules-list/add', {
      infoBase: this.rulesService.ui_modes.EDIT,
      idRule: idRule
    }]);
  }

  onRemoveAddRule(row: any) {
    this.rulesService.deleteAuditRule(row).subscribe(res => {

      if (res) {
        this.srvMessage.add({
          severity: 'success',
          summary: this.srvTranslate.instant('common.success'),
          detail: this.srvTranslate.instant('audit.operation_successful')
        });
        this.table.refresh();
      } else {
        this.srvMessage.add({
          severity: 'error',
          summary: this.srvTranslate.instant('common.error'),
          detail: this.srvTranslate.instant('audit.genericActionError')
        });
      }
    });

  }

  onRecoverAddRule(row: any) {
    this.rulesService.recoverAuditRule(row).subscribe(res => {

      if (res) {
        this.srvMessage.add({
          severity: 'success',
          summary: this.srvTranslate.instant('common.success'), // Usa la traduzione per "Success"
          detail: this.srvTranslate.instant('audit.operation_successful')
        });
        this.table.refresh();
      } else {
        this.srvMessage.add({
          severity: 'error',
          summary: this.srvTranslate.instant('common.error'),
          detail: this.srvTranslate.instant('audit.genericActionError')
        });
      }
    });

  }

  onClosePopupInfo() {
    this.showPopupInfoInsideTable = false;
  }

  onDetailsLinkUnLinkRule(event: any) {
    this.rulesService.linkUnlinkAuditRule(event).subscribe(res => {
      if (res) {
        this.srvMessage.add({
          severity: 'success',
          summary: this.srvTranslate.instant('common.success'), // Usa la traduzione per "Success"
          detail: this.srvTranslate.instant('audit.operation_successful')
        });
        this.table.refresh();
      } else {
        this.srvMessage.add({
          severity: 'error',
          summary: this.srvTranslate.instant('common.error'),
          detail: this.srvTranslate.instant('audit.genericActionError')
        });
      }
    });

  }

  loadTypeRules() {
    this.rulesService.getActionRulesTypeList().subscribe(res => {
      this.actionsRulesTypeCombo = [];
      this.actionsRulesType = [];
      this.actionsRulesTypeCombo.push({ label: this.srvTranslate.instant('common.all'), value: null });

      if (res) {
        res.forEach(typeRule => {
          this.actionsRulesTypeCombo.push({ label: `${typeRule.description}`, value: String(typeRule.id) })
          this.actionsRulesType.push(typeRule);
        });
      }
    });
  }

  getRuleType(row: any) {
    let elabrow = this.actionsRulesType.find(x => x.id == row.auditRulesTypeId)
    let retVal = "";
    if (elabrow) {
      retVal = elabrow.description;

    }
    return retVal;
  }

  getStatusRuleType(row: any) {
    let elabrow = this.statusList.find(x => x.value == row.flg_state)
    let retVal = "";
    if (elabrow) {
      retVal = elabrow.label;

    }
    return retVal;
  }

  onInfoAddRule(row: any) {
    if (row === undefined) {
      console.error("row is undefined!");
      return;
    }
    this.auditRuleObject = new AuditRuleObject();
    if (!this.showPopupInfoInsideTable) {
      this.rulesService.getAuditRuleGlobalObject(row).subscribe(res => {
        if (res) {
          //da capire come prendere le label se fare altra get)
          this.auditRuleObject = res;
          this.showPopupInfoInsideTable = true;
        }

      });

    }
  }
  changeStatusRule(col: any, event: any) {
    if (event.value === '0') { //col.field = 'flg_state'
      this.table.updateTableFilter(col.field, event.value, 'equals')
      let index = this.table.filter.search.findIndex(f => f.key === 'flg_dpl');
      if (index > -1) {
        this.table.filter.search.splice(index, 1);
      }
    } else if (event.value === '1') {
      this.table.updateTableFilter('flg_dpl', event.value, 'equals')
      let index = this.table.filter.search.findIndex(f => f.key === col.field);
      if (index > -1) {
        this.table.filter.search.splice(index, 1);
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/views/audit/rules/rules.component.ts